import './index.less'
import VisibleComponent from "../VisibleComponent.js"
import Panel from "../Panel"
import SimpleBanner from "../SimpleBanner"
import i18nTools from '../../../../common/local/format'

const tpl = `
  <div class="mtg-dialog-banner"></div>
`

class DialogBanner extends VisibleComponent {
  // 需要传入campaign, onClick, onClose
  constructor(options) {
    super(options)
    this.template = tpl
    this.banner = new SimpleBanner({
      icon: options.campaign.icon_url,
      ad: false,
      buttonText: i18nTools.formatByUA('_switch_one'),
      buttonClassName: options.buttonClassName,
      title: options.campaign.title,
      star: options.campaign.rating,
      iconShape: "circle",
      iconSize: "1",
      theme: "transparent",
      onButtonClick: options.onClick,
    })
    this.panel = new Panel({
      width: '100%',
      title: i18nTools.formatByUA('_not_interested_in_this_video', { second: '' }),
      titleClassName: ['dialog-title', 'mtg-color-white'],
      titleToolsClassName: ['top-align'],
      titleTools: [{
        type: 'flatClose',
        theme: 'black',
        onClick: options.onClose,
      }],
      content: this.banner,
    })

    super.init()
    this.panel.appendTo(this.element)
    this.panel.show()
  }

  setTitleCountdown(remainSecond) {
    const text = i18nTools.formatByUA('_not_interested_in_this_video', {
      second: remainSecond + 's'
    })
    this.panel.setTitle(text)
  }

  getId() {
    return 'Dialog Banner'
  }
}

export default DialogBanner